"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let NAVOnlineInvoiceInterfacePanel = class NAVOnlineInvoiceInterfacePanel extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
        this.$$cache_selectedCompanies = new core_1.ComponentValueCache(this, "selectedCompanies", "NAVOnlineInvoiceInterface.selectedCompanies");
    }
    items;
    async $$load_items() {
        return this.$fn.fetch('list_nav_online_interface_setting').then(data => _.orderBy(data, ['company_name']));
    }
    selectedCompanies;
    ux;
    b_3343864469950044_style;
    b_5477420070495986_style;
    b_6337614691287098_style;
    b_2406129194387753_style;
    dataMembers = ['items', 'selectedCompanies', 'ux', 'b_3343864469950044_style', 'b_5477420070495986_style', 'b_6337614691287098_style', 'b_2406129194387753_style'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                items: null,
                selectedCompanies: {},
                ux: null,
                b_3343864469950044_style: {
                    width: "1px",
                },
                b_5477420070495986_style: {
                    width: "1px",
                    "vertical-align": "middle",
                },
                b_6337614691287098_style: {
                    width: "1px",
                    "vertical-align": "middle",
                },
                b_2406129194387753_style: {
                    width: "auto",
                },
            },
        };
    }
    get selectedCompanyValues() {
        if (this.loaded) {
            return _.keys(_.pickBy(this.selectedCompanies));
        }
        return null;
    }
    async evh_7315092382398562_reload(event, scope) {
        return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
    }
    async act_5615156174146796_showModal_4664_getActionArgs($event) {
        return {
            name: "NAVOnlineInvoiceInterfaceSettings",
            props: {
                companyId: $event.scope.item.company_id,
            },
        };
    }
    async evh_5615156174146796_click(event, scope) {
        return await this.actions.evh_5615156174146796_click.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_reloadComponentData_4662 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7315092382398562_reload_4661 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_reloadComponentData_4662,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7315092382398562_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_reload_4661],
        });
        const act_5615156174146796_reloadComponentData_4666 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_5615156174146796_close_4665 = new core_1.actions.EventHandlerImpl({
            action: act_5615156174146796_reloadComponentData_4666,
            event: "close",
            displayName: "reloadComponentData",
        });
        const act_5615156174146796_showModal_4664 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_5615156174146796_showModal_4664_getActionArgs,
            events: [evh_5615156174146796_close_4665],
        });
        const evh_5615156174146796_click_4663 = new core_1.actions.EventHandlerImpl({
            action: act_5615156174146796_showModal_4664,
            event: "click",
            displayName: "showModal",
        });
        const evh_5615156174146796_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5615156174146796_click_4663],
        });
        return {
            act_7315092382398562_reloadComponentData_4662,
            evh_7315092382398562_reload_4661,
            evh_7315092382398562_reload,
            act_5615156174146796_reloadComponentData_4666,
            evh_5615156174146796_close_4665,
            act_5615156174146796_showModal_4664,
            evh_5615156174146796_click_4663,
            evh_5615156174146796_click,
        };
    }
};
NAVOnlineInvoiceInterfacePanel = __decorate([
    (0, vue_property_decorator_1.Component)()
], NAVOnlineInvoiceInterfacePanel);
exports.default = NAVOnlineInvoiceInterfacePanel;
vue_property_decorator_1.Vue.component("NAVOnlineInvoiceInterfacePanel", NAVOnlineInvoiceInterfacePanel);
